"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsGallery = OfferDetailsGallery;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const get_mux_video_thumbnail_url_1 = require("@src/shared/get-mux-video-thumbnail-url");
const AssetDetailModal_1 = require("@src/components/modules/AssetDetailModal");
const OfferDetailsGallery_style_1 = require("./OfferDetailsGallery.style");
function getAssetImgUrl(asset) {
    if (asset.type === types_1.AssetType.IMAGE) {
        return (0, get_cdn_image_url_1.getCdnImageUrl)({
            file: asset.cloudinaryPublicId,
            transformation: 'w_200,c_scale',
            shouldIncludeEnvironmentPart: false,
        });
    }
    if (asset.type === types_1.AssetType.VIDEO) {
        return (0, get_mux_video_thumbnail_url_1.getMuxVideoThumbnailUrl)({ muxPublicPlaybackId: asset.muxPublicPlaybackId, width: 200 });
    }
    throw new Error('Assets in offer gallery should be only images and videos');
}
function GalleryAssetCard({ asset, onClick }) {
    return ((0, jsx_runtime_1.jsx)(OfferDetailsGallery_style_1.GalleryAssetCardContainer, { onClick: onClick, children: (0, jsx_runtime_1.jsx)(OfferDetailsGallery_style_1.AssetImg, { src: getAssetImgUrl(asset) }) }));
}
function OfferDetailsGallery({ gallery, shouldHideTitle }) {
    const [isAssetsModalOpen, setIsAssetsModalOpen] = react_1.default.useState(false);
    const [initialAssetId, setInitialAssetId] = react_1.default.useState(null);
    const openAssetsModal = (assetId) => {
        setIsAssetsModalOpen(true);
        setInitialAssetId(assetId);
    };
    const closeAssetsModal = () => {
        setIsAssetsModalOpen(false);
        setInitialAssetId(null);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "m-t-l m-b-l", children: [!shouldHideTitle && (0, jsx_runtime_1.jsx)("h3", { children: gallery[types_1.EOfferGalleryKey.title] }), (0, jsx_runtime_1.jsx)(OfferDetailsGallery_style_1.GalleryAssetsContainer, { children: gallery.assets.map(asset => ((0, jsx_runtime_1.jsx)(GalleryAssetCard, { asset: asset, onClick: () => openAssetsModal(asset.id) }, asset.id))) })] }), (0, jsx_runtime_1.jsx)(AssetDetailModal_1.DetailsAssetsModal, { isOpen: isAssetsModalOpen, assets: gallery.assets, closeModal: closeAssetsModal, initialAssetId: initialAssetId })] }));
}
